import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CyclopsHttp } from './app.http';

@Injectable({
  providedIn: 'root',
})
export class AumyeSecurityGuardService {
  constructor(private cyclopsHttp: CyclopsHttp) {}
  onVisitorCheckIn(params: any): Observable<any> {
    return this.cyclopsHttp.post('VisitorCheckIn', params);
  }
  onVisitorCheckOut(params: any): Observable<any> {
    return this.cyclopsHttp.post('VisitorCheckOut', params);
  }
  onVisitorMultipleCheckIn(params: any): Observable<any> {
    return this.cyclopsHttp.post('VisitorMultipleCheckIn', params);
  }
  onVisitorMultipleCheckOut(params: any): Observable<any> {
    return this.cyclopsHttp.post('VisitorMultipleCheckOut', params);
  }
  onCheckVisitorVehicleDetails(params: any): Observable<any> {
    return this.cyclopsHttp.post('GetANPRDetails', params);
  }
}
